//lib
import { MDBBtn } from "mdb-react-ui-kit";

export default function Button(props) {
  const { type, variant, disabled, className, onClick } = props;

  return (
    <MDBBtn
      type={type ? type : "button"}
      className={`
        ${className ? className : ""}
        element _button 
        ${variant === "outline" ? "--outline" : "--solid"} 
        ${disabled ? "not-allowed" : "pointer"}
      `}
      disabled={disabled ? disabled : false}
      onClick={onClick ? onClick : undefined}
    >
      {props.children}
    </MDBBtn>
  );
}
